export default __webpack_public_path__ + "static/media/d7c64a4dc86c7812fd5c9fb2cd70a3321581611380193.3c8ff8fd.webp";